import { render, staticRenderFns } from "./organization-datasource-data-view.vue?vue&type=template&id=0a33795b"
import script from "./organization-datasource-data-view.vue?vue&type=script&lang=js"
export * from "./organization-datasource-data-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports